import { Button } from "@/components/ui/button";
import { COMMON_CLASSES } from "@/lib/jobConstants";
import { ArrowLeft } from "lucide-react";

interface JobDetailsHeaderProps {
  onBack: () => void;
}

export function JobDetailsHeader({ onBack }: JobDetailsHeaderProps) {
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onBack} 
        className="text-gray-600 hover:text-gray-900"
      >
        <ArrowLeft className="h-5 w-5 text-orange-600" />
      </Button>
      <div>
        <h1 className={COMMON_CLASSES.text.heading}>Job Details</h1>
        <p className={COMMON_CLASSES.text.subheading}>
          Review job details and submit your referral
        </p>
      </div>
    </div>
  );
}
